import { render, staticRenderFns } from "./recurrence-setup.vue?vue&type=template&id=38c7b8da&"
import script from "./recurrence-setup.vue?vue&type=script&lang=ts&"
export * from "./recurrence-setup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports